import "./NewsAppPushMessagesNotification.scss";

export default {
  name: "NewsAppPushMessagesNotification",
  props: ["news"],
  data() {
    return {
      dialogVisible: false,
      staticInformationList: [
        {
          icon: "$LightBulbOn",
          title: "Hohe Relevanz",
          text: "Starke Trigger-Wörter & klare Handlungsaufforderung"
        },
        {
          icon: "$AlarmClock",
          title: "Perfektes Timing",
          text: "Inhalt bezieht sich auf zeitkritische Aktion"
        },
        {
          icon: "$UsersViewfinder",
          title: "Zielgruppen-Fit",
          text: "Besonders wirksam für Inaktive Nutzer (48h+)"
        }
      ],
      showSuggestions: true,
      maxNumberOfSuggestions: 20,
      lastSeenIndex: -1
    };
  },
  computed: {
    selectedPrincipalId() {
      return this.$store.state.selectedPrincipal?.id;
    },
    notify() {
      if (this.dialogVisible) {
        return false;
      }
      if (!this.news?.length) {
        return false;
      }
      const lastSeen = JSON.parse(
        localStorage.getItem("lastSeenNewsAppPushMessageSuggestion") ?? "{}"
      )[this.selectedPrincipalId];
      if (!lastSeen?.length) {
        return true;
      }

      for (let i = 0; i < this.news?.length; i++) {
        if (this.news[i]._id === lastSeen) {
          this.lastSeenIndex = i;
          return true;
        }
      }
      return false;
    },
    newSuggestions() {
      if (this.lastSeenIndex === -1) {
        return this.news.length;
      }
      return this.lastSeenIndex;
    },
    suggestions() {
      if (this.showSuggestions) {
        return this.news;
      }
      return [this.news?.[0]];
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
      this.setLastSeenSuggestion();
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    goToNewsEditDialog(newsId) {
      window.open(`/news/news/update/${newsId}?action=createPushMessage`);
    },
    setLastSeenSuggestion() {
      const lastSeen = JSON.parse(
        localStorage.getItem("lastSeenNewsAppPushMessageSuggestion") ?? "{}"
      );
      lastSeen[this.selectedPrincipalId] = this.news[0]?._id ?? "";
      localStorage.setItem(
        "lastSeenNewsAppPushMessageSuggestion",
        JSON.stringify(lastSeen)
      );
    }
  }
};
